<template>
  <footer class="footer">
    <div class="footer-top pt-20 pb-20">
      <div class="container-fluid">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-3 col-12">
            <div class="d-flex justify-content-start align-items-center ">
              <div class="d-flex justify-content-center align-items-center flex-column pt-2">
              <img src="@/assets/img/logo/vision.svg" alt="" width="60"/>
              <div>
                <a  class="button-30 w-100" href="mailto:info@gulftic.com">

             تقديم بلاغ أو شكوى</a>
            </div>
            </div>
            </div>

          </div>

          <div class="col-md-6 col-12">
            <div
              class="footer-widget-social d-flex justify-content-center align-items-center"
            >
              <div class="mx-2 with-border">
                <div class="footer-subtitle">
                  <a href="tel:00966595406064">
                               00966595406064
                   </a>
                  <div class="conOfFooterIcon">
                    <vue-feather
                      size="20"
                      stroke="#fff"
                      type="phone"
                    ></vue-feather>
                  </div>
                </div>
              </div>
              <div class="mx-2 with-border">
                <div class="footer-subtitle">
                  الرياض حي الياسمين شارع الكفاح

                  <div class="conOfFooterIcon">
                    <vue-feather
                      size="20"
                      stroke="#fff"
                      type="map-pin"
                    ></vue-feather>
                  </div>
                </div>
              </div>
              <div class="mx-2">
                <div class="footer-subtitle">
                  <a href="mailto:info@gulftic.com">
                    info@gulftic.com
                  </a>

                  <div class="conOfFooterIcon">
                    <vue-feather
                      size="20"
                      stroke="#fff"
                      type="mail"
                    ></vue-feather>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-12">
            <b-row class="align-items-center justify-content-end">
              <b-col md="4" cols="12" class="border-left p-0">
                <div class="text-white ownTitle text-center text-uppercase pb-1">
                  Supervised By
                </div>
                <div class=" d-flex justify-content-center align-items-center">
                  <img
                    src="@/assets/img/footer/ministry.jpeg"
                    alt=""
                    width="50"
                  />
                </div>
              </b-col>
              <b-col md="4" cols="12" class="p-0">
                <div class="text-white ownTitle text-center text-uppercase pb-1">
                  Owned By
                </div>
                <div class=" d-flex justify-content-center align-items-center">

                <router-link to="/">
                  <img
                    src="@/assets/img/logo/logo-white.png"
                    alt=""
                    width="70"
                  />
                </router-link>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-area pt-2 pb-2">
      <div class="container-fluid ">
        <div class="footer-copyright">
          <b-row class="justify-content-between">
            <b-col md="3" class=" fw-bold text-white">
              <div class="footer-bottom-text">
                جميع الحقوق محفوظة ©
              2024 ...........
              </div>
            </b-col>
            <b-col md="3" class=" fw-bold text-white text-start">
              <div class="footer-bottom-text">

              سياسة الخصوصية - و الاسئلة الشائعة
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HomeFooter",
  components: {},
  data() {
    return {
      visible: false,
      index: 0,
    };
  },
  methods: {
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.border-left {
  border-left: 1px solid #fff; /* You can customize the border style and color */
}
.ownTitle{
  font-size: 10px;
}
</style>